var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup27659(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.91 5.364v12.272h-4.092V15.25h-1.364v2.386h-4.09V5.364h9.545zM13.181 8.09h1.364V6.727h-1.364v1.364zm-2.728 0h1.364V6.727h-1.364v1.364zm-2.727 0h1.364V6.727H7.727v1.364zm5.455 2.727h1.364V9.455h-1.364v1.363zm-2.728 0h1.364V9.455h-1.364v1.363zm-2.727 0h1.364V9.455H7.727v1.363zm5.455 2.728h1.364v-1.364h-1.364v1.364zm-2.728 0h1.364v-1.364h-1.364v1.364zm-2.727 0h1.364v-1.364H7.727v1.364zm5.455 2.727h1.364v-1.364h-1.364v1.364zm-5.455 0h1.364v-1.364H7.727v1.364zM17.273 4H5v15h12.273V4z",
    fill: "#7E7E7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup27659);
export default __webpack_public_path__ + "static/media/Group 27659.421f25b1952a78955a221eb62c7bcdf6.svg";
export { ForwardRef as ReactComponent };